<template>
    <!--nav-->
    <nav class="navbar navbar-default no-margin app-sidebar-nav">
        <!-- Brand and toggle get grouped for better mobile display -->
        <div class="navbar-header fixed-brand">
            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" id="menu-toggle">
                <span class="glyphicon glyphicon-th-large" aria-hidden="true"></span>
            </button>
            <a class="navbar-brand" href="javascript:void(0)"><img src="/static/images/logo.webp" alt="Velocity Vehicle Group" width="161" height="32"></a>
        </div>
        <!-- navbar-header-->
        <div class="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
            <ul class="nav navbar-nav">
                <li class="active">
                    <button class="navbar-toggle collapse in" data-toggle="collapse" id="menu-toggle-2"> 
                        <img src="/static/images/menubar.png" alt="Menu" class="menubar" width="42" height="23">
                    </button>
                </li>
            </ul>
        </div>
        <!--notification-->
        <!--<div class="notification">
            <a href="#">
                <img src="/static/images/notification-bell.png" alt="Notification">
            </a>
        </div>-->
        <!--notification-->
        <!--userinfo-->
        <div class="user-info">
            <div class="user-info-container">
                <div class="dropdown">
                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <div class="dropdown-user">
                            <!--<div class="image"><img :src="image" alt="User" width="48" height="48"></div>-->
                            <div class="username-letter">{{loggedin_user_img}}</div>
                            <div class="dropdown-user-right">
                                <div class="username">{{formatString(loggedin_user)}} {{formatString(loggedin_user_last_name)}}</div>
                                <br/>
                                <div class="usermailid">{{username}}</div>
                            </div>
                        </div>
                    </button>
                    <div class="dropdown-menu">
                        <!--<a class="dropdown-item" href="#">My Profile</a>-->
                        <router-link v-if="user_role == 1" class="dropdown-item"  v-bind:to="{name: 'AddEditMenu'}">Edit Menu</router-link>
                        <!--<a class="dropdown-item" href="#">Inbox</a>
                        <a class="dropdown-item" href="#">Account Setting</a>-->
                        <router-link v-if="user_role == 1" class="dropdown-item"  v-bind:to="{name: 'UserList'}">User</router-link>
                        <router-link v-if="user_role == 1" class="dropdown-item"  v-bind:to="{name: 'ListCalendarKey'}">Calendar Keys</router-link>
                        <a class="dropdown-item" href="javascript:void(0)" v-on:click.prevent="logout">Logout</a>
                    </div>
                </div>
            </div>
        </div>
        <!--userinfo-->
        <!-- bs-example-navbar-collapse-1 -->
    </nav>
    <!--nav-->
</template>

<script>

    import Vue from 'vue';
    import EventBus from '.././event-bus';
    var contex;
    import {commonMixins} from '../../mixins/commonMixins';

    export default {
        name: "Header",
        mixins: [commonMixins],
        data: () => ({
                profileColor: "",
                isShowLoggedinfields: false,
                loggedin_user_img: '',
                loggedin_user: '',
                loggedin_user_last_name: '',
                role: "",
                username: "",
                image: "/static/images/default.jpg"
            }),
        beforeMount: function () {
            contex = this;
        },
        mounted: function () {
            var self = this;
            var userObj = localStorage.getItem('user_obj');
            if (userObj && userObj != null) {
                var profileColor = localStorage.getItem('profileColor');
                if (profileColor && profileColor != null) {
                    self.profileColor = profileColor;
                } else {
                    self.profileColor = self.gerRandomColor();
                    localStorage.setItem("profileColor", self.profileColor);
                }
                if (self.profileColor != "") {
                    /*$(".username-letter").css({"background": self.profileColor});*/
                }
            }
            //self.$store.dispatch('getRole');
        },
        methods: {

            logout: function () {
                var ssoLogin = true;
                localStorage.clear();
                // window.location.href = "/";
                // Auto-logout Current Project From SSO
                window.location.href = process.env.VUE_APP_SSO_ROOT_URL + "/logout?redirect_url=" + process.env.VUE_APP_FRONT_ROOT_URL + '&slug=' + process.env.VUE_APP_PROJECT_SLUG;
            },

            formatString: function (data) {
                var self = this;
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp.toUpperCase();
            },

        },

    };

    EventBus.$on('logged-in', function (isLogin, name, lastName, username) {
        contex.isShowLoggedinfields = isLogin;
        contex.loggedin_user = name.trim();
        contex.loggedin_user_last_name = lastName.trim();
        contex.loggedin_user_img = (contex.loggedin_user.charAt(0) + contex.loggedin_user_last_name.charAt(0)).toUpperCase();
        contex.username = username;
        if (contex.loggedin_user_img == "") {
            contex.loggedin_user_img = (contex.username.charAt(0) + contex.username.charAt(1)).toUpperCase();
        }
        //contex.role = role;
        //contex.image = "/static/images/default.jpg";

        /* if (file_path != null){
         contex.image = file_path;
         }else{
         contex.image = "/static/images/default.jpg";
         } */

    });

</script>


// WEBPACK FOOTER //
// src/components/partials/Header.vue